import { render, staticRenderFns } from "./AssignEntriesForm.vue?vue&type=template&id=79b71fa7&scoped=true&"
import script from "./AssignEntriesForm.vue?vue&type=script&lang=js&"
export * from "./AssignEntriesForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignEntriesForm.vue?vue&type=style&index=0&id=79b71fa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b71fa7",
  null
  
)

export default component.exports